import { Component, OnInit } from '@angular/core';
import {AuthAndACLService} from '../auth_and_acl/authAndACL.service';
import{ Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-token',
  templateUrl: './token.component.html',
  styleUrls: [
    './token.component.css',
    '../../../node_modules/csspin/csspin.css'
  ]
})
export class TokenComponent implements OnInit {
  token_acesso: string;

  constructor(private authAndACL: AuthAndACLService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.setToken();
  }

  setToken(): void {
    this.route.params.subscribe((params: Params) => {

      let token:string = params['token'];
      let path:string = params['path'];

      this.authAndACL.setUser(path, token);

      this.token_acesso = localStorage.getItem('token_acesso');

      //console.log('Token setado:', this.token_acesso);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/token/token.component.ts